/* eslint-disable default-case */
import React from "react";
// Msal imports
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth-config";
import proapps from "../assets/img/proapps.svg";

const Login = () => {
  const { instance } = useMsal();

  const handleRedirect = () => {
    instance
      .loginRedirect({
        ...loginRequest,
        prompt: "create",
      })
      .catch((err) => console.error(err));
  };

  return (
    <div className="fd">
      <div className="fd ht_94vh rds_30 mainBox m_tb_20 p_b_30">
        <div className="mainSize_350 logbox shadow_6">
          <div className="fd">
            <div className="fd text-center">
              <img src={proapps} width="180"></img>
            </div>
          </div>
          <div className="fd m_t_30 inp">
            <div className="fd text-center">
              <p className="fd h5 font-weight-bold">Login or Sign up</p>

              <p className="text-secondary">You can access apps after log in</p>

              <button
                className="fd log_btn font-weight-bold"
                onClick={handleRedirect}
              >
                <i class="bi bi-windows"></i>{" "}
                <span style={{ paddingLeft: "10px" }}>Login with Proounce</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
